export const iconFontAwesomeCharityHandsHoldingCircle = (
	<i className="fa-solid fa-hands-holding-circle"></i>
);
